document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var answer = this.nextElementSibling;
      var isOpen = answer.classList.contains('open');
      document.querySelectorAll('.faq-answer').forEach(function(a) { a.classList.remove('open'); });
      document.querySelectorAll('.faq-question').forEach(function(b) { b.classList.remove('open'); });
      if (!isOpen) {
        answer.classList.add('open');
        this.classList.add('open');
      }
    });
  });
});